(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-responsive-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cusotm-responsive-hero')) return;

    class CusotmResponsiveHero extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.hero = this.querySelector('.cusotm-responsive-hero');
        this.viewport = this.querySelector('.cusotm-responsive-hero__viewport');
        this.track = this.querySelector('.cusotm-responsive-hero__track');

        if (!this.hero || !this.viewport || !this.track) return;

        this.track.querySelectorAll('[data-cusotm-loop-clone]').forEach((element) => element.remove());

        this.slides = Array.from(this.track.children).filter((element) =>
          element.classList.contains('cusotm-hero-slide')
        );

        if (this.slides.length === 0) {
          this.slides = Array.from(this.track.children);
        }

        this.index = 0;
        this.delay = Math.max(1000, Number(this.dataset.delay) || 6000);
        this.scrollBehavior = this.dataset.scrollBehavior === 'rewind' ? 'rewind' : 'infinite';
        this.loop = this.scrollBehavior === 'infinite';
        this.rewind = this.scrollBehavior === 'rewind';
        this.autoplayEnabled = this.dataset.autoplay !== 'false';
        this.clickToggleEnabled = this.dataset.clickToggle !== 'false';
        this.holdPauseEnabled = this.dataset.holdPause !== 'false';
        this.holdDelay = Math.max(100, Number(this.dataset.holdDelay) || 200);
        this.showPagination = this.dataset.showPagination !== 'false';
        this.showPause = this.dataset.showPause !== 'false';
        this.controlsMode = this.dataset.controlsMode === 'fixed' ? 'fixed' : 'slide';
        this.reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
        this.mobileQuery = window.matchMedia?.('(max-width: 749px)');

        this.userPaused = false;
        this.holdPaused = false;
        this.dragPaused = false;
        this.hiddenPaused = false;
        this.progress = 0;
        this.raf = null;
        this.mouseDragFrame = null;
        this.pendingMouseScrollLeft = null;
        this.mouseSettleFrame = null;
        this.isMouseSettling = false;
        this.startedAt = 0;
        this.pointerState = null;
        this.nativeTouchState = null;
        this.nativeReleaseTarget = null;
        this.holdTimer = null;
        this.onSelectionChange = null;
        this.loopClonesEnabled = false;
        this.physicalIndex = 0;
        this.pendingNavigationIndex = null;
        this.pendingRewind = false;
        this.scrollSettleTimer = null;
        this.suppressScrollEvents = false;
        this.isViewportScrolling = false;
        this.resumeAfterScroll = false;

        this.setupLoopSlides();
        this.buildSlideControls();
        this.bindEvents();
        this.goTo(0, false, false);

        if (this.slides.length > 1) {
          requestAnimationFrame(() => this.startProgress(true));
        }
      }

      disconnectedCallback() {
        this.cancelProgressFrame();
        this.cancelMouseDragFrame();
        this.cancelMouseSettle();
        this.clearHoldTimer();
        this.clearScrollSettleTimer();
        this.slideResizeObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('resize', this.onResize);
        this.viewport?.removeEventListener('scroll', this.onViewportScroll);
        this.viewport?.removeEventListener('scrollend', this.onViewportScrollEnd);
        this.viewport?.removeEventListener('touchstart', this.onNativeTouchStart);
        this.viewport?.removeEventListener('touchmove', this.onNativeTouchMove);
        this.viewport?.removeEventListener('touchend', this.onNativeTouchEnd);
        this.viewport?.removeEventListener('touchcancel', this.onNativeTouchCancel);
        if (this.onSelectionChange) document.removeEventListener('selectionchange', this.onSelectionChange);
      }

      setupLoopSlides() {
        this.slides.forEach((slide, index) => {
          slide.dataset.cusotmLogicalIndex = String(index);
        });

        this.loopClonesEnabled = this.loop && this.slides.length > 1;

        if (!this.loopClonesEnabled) {
          this.physicalSlides = [...this.slides];
          this.physicalIndex = 0;
          return;
        }

        const firstClone = this.createLoopClone(this.slides[0], 0);
        const lastIndex = this.slides.length - 1;
        const lastClone = this.createLoopClone(this.slides[lastIndex], lastIndex);

        this.track.insertBefore(lastClone, this.slides[0]);
        this.track.appendChild(firstClone);

        this.physicalSlides = Array.from(this.track.children);
        this.physicalIndex = 1;
      }

      createLoopClone(sourceSlide, logicalIndex) {
        const clone = sourceSlide.cloneNode(true);
        clone.dataset.cusotmLoopClone = '';
        clone.dataset.cusotmLogicalIndex = String(logicalIndex);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.removeAttribute('data-shopify-editor-block');

        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
          element.removeAttribute('data-shopify-editor-block');
        });

        return clone;
      }

      logicalToPhysical(index) {
        return this.loopClonesEnabled ? index + 1 : index;
      }

      buildSlideControls() {
        this.controlSets = [];
        this.pauseButtons = [];

        this.querySelectorAll('[data-cusotm-generated-controls]').forEach((element) => element.remove());

        if (this.slides.length <= 1 || (!this.showPagination && !this.showPause)) return;

        if (this.controlsMode === 'fixed') {
          const controlSet = this.createControls(null);
          this.hero.appendChild(controlSet.controls);
          this.controlSets.push(controlSet);
        } else {
          this.physicalSlides.forEach((slide) => {
            const ownerIndex = Number(slide.dataset.cusotmLogicalIndex);
            const controlSet = this.createControls(ownerIndex);
            slide.appendChild(controlSet.controls);
            this.controlSets.push(controlSet);
          });
        }

        this.updateControlsUI();
      }

      createControls(ownerIndex) {
        const controls = document.createElement('div');
        controls.className = 'cusotm-responsive-hero__controls';
        controls.dataset.cusotmGeneratedControls = '';

        const paginationButtons = [];

        if (this.showPagination) {
          const pagination = document.createElement('div');
          pagination.className = 'cusotm-responsive-hero__pagination';
          pagination.setAttribute('aria-label', 'Hero Slides');

          this.slides.forEach((_, targetIndex) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'cusotm-responsive-hero__pagination-button';
            button.setAttribute('aria-label', `Slide ${targetIndex + 1} anzeigen`);
            button.innerHTML = `
              <span class="cusotm-responsive-hero__pagination-progress"></span>
              <span class="cusotm-responsive-hero__pagination-pause-indicator" aria-hidden="true"></span>
            `;
            button.addEventListener('click', (event) => {
              event.stopPropagation();
              this.goTo(targetIndex, true, true);
            });
            pagination.appendChild(button);
            paginationButtons.push(button);
          });

          controls.appendChild(pagination);
        }

        let pauseButton = null;

        if (this.showPause) {
          pauseButton = document.createElement('button');
          pauseButton.className = 'cusotm-responsive-hero__pause';
          pauseButton.type = 'button';
          pauseButton.setAttribute('aria-label', 'Slideshow pausieren');
          pauseButton.setAttribute('aria-pressed', 'false');
          pauseButton.innerHTML = `
            <span class="cusotm-responsive-hero__pause-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M7 5h3v14H7zM14 5h3v14h-3z"></path>
              </svg>
            </span>
            <span class="cusotm-responsive-hero__play-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M8 5v14l11-7z"></path>
              </svg>
            </span>
          `;
          pauseButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.togglePause();
          });
          controls.appendChild(pauseButton);
          this.pauseButtons.push(pauseButton);
        }

        return { ownerIndex, controls, paginationButtons, pauseButton };
      }

      bindEvents() {
        this.hero.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.hero.addEventListener('pointermove', (event) => this.onPointerMove(event));
        this.hero.addEventListener('pointerup', (event) => this.onPointerUp(event));
        this.hero.addEventListener('pointercancel', (event) => this.cancelPointerInteraction(event));

        this.onViewportScroll = () => {
          if (this.suppressScrollEvents) return;

          this.isViewportScrolling = true;

          const releasedTouchIsSettling = Boolean(this.nativeReleaseTarget) && !this.nativeTouchState;
          if (!releasedTouchIsSettling) {
            this.dragPaused = true;
            this.stopProgress(true);
          }

          if (this.pointerState?.pointerType === 'touch') {
            this.pointerState.moved = true;
            this.pointerState.axis = 'horizontal';
            this.clearHoldTimer();
          }

          if (!this.pointerState?.dragging && !this.isMouseSettling) {
            this.scheduleScrollSettle();
          }
        };

        this.onViewportScrollEnd = () => {
          if (
            this.suppressScrollEvents ||
            this.pointerState?.dragging ||
            this.isMouseSettling ||
            this.nativeTouchState
          ) return;

          this.settleViewportScroll(true);
        };

        this.viewport.addEventListener('scroll', this.onViewportScroll, { passive: true });
        this.viewport.addEventListener('scrollend', this.onViewportScrollEnd, { passive: true });

        this.onNativeTouchStart = (event) => {
          if (event.touches.length !== 1) return;
          if (event.target.closest('a, button, input, textarea, select, label')) return;

          const interactionSurface = event.target.closest('.cusotm-hero-media, .cusotm-hero-content');
          if (!interactionSurface) return;

          const content = event.target.closest('.cusotm-hero-content');
          const slide = interactionSurface.closest('.cusotm-hero-slide');
          if (!slide) return;

          /* A new gesture must be allowed immediately, even while Safari is still
             finishing the previous native snap. The logical slide was already
             committed on release, so there is no reason to wait for scrollend. */
          this.nativeReleaseTarget = null;
          this.clearScrollSettleTimer();

          const touch = event.touches[0];
          const now = performance.now();
          this.nativeTouchState = {
            startX: touch.clientX,
            startY: touch.clientY,
            lastX: touch.clientX,
            lastY: touch.clientY,
            lastTime: now,
            velocityX: 0,
            moved: false,
            axis: null,
            basePhysicalIndex: this.physicalIndex,
            startScrollLeft: this.viewport.scrollLeft,
            contentElement: content || null,
            selectionSnapshot: content ? this.captureSelectionSnapshot() : null,
            textSelectionDetected: false
          };
        };

        this.onNativeTouchMove = (event) => {
          const state = this.nativeTouchState;
          if (!state || event.touches.length !== 1) return;

          const touch = event.touches[0];
          const dx = touch.clientX - state.startX;
          const dy = touch.clientY - state.startY;
          const absX = Math.abs(dx);
          const absY = Math.abs(dy);
          const distance = Math.hypot(dx, dy);
          const threshold = 8;
          const now = performance.now();
          const elapsed = Math.max(1, now - state.lastTime);

          state.velocityX = (touch.clientX - state.lastX) / elapsed;
          state.lastX = touch.clientX;
          state.lastY = touch.clientY;
          state.lastTime = now;

          if (distance > threshold) state.moved = true;

          if (!state.axis && distance > threshold) {
            if (absX > absY * 1.18) {
              state.axis = 'horizontal';
            } else if (absY > absX * 1.18) {
              state.axis = 'vertical';
            }
          }
        };

        this.finishNativeTouch = (event) => {
          const state = this.nativeTouchState;
          this.nativeTouchState = null;
          if (!state) return;

          const touch = event?.changedTouches?.[0];
          const endX = touch?.clientX ?? state.lastX;
          const endY = touch?.clientY ?? state.lastY;
          const dx = endX - state.startX;
          const dy = endY - state.startY;

          const nativeScrollDistance = Math.abs(this.viewport.scrollLeft - state.startScrollLeft);
          if (nativeScrollDistance > 4) state.moved = true;

          /* A fast drag across selectable text can produce the same touch delta as
             a swipe and may even end as touchcancel on iOS. If the browser has
             created/changed a real text selection inside this content block, this
             gesture belongs to text selection and must never advance the slider. */
          if (state.contentElement && (state.textSelectionDetected || this.hasChangedTextSelection(state))) {
            this.pendingNavigationIndex = null;
            this.pendingRewind = false;
            this.nativeReleaseTarget = null;
            this.updateControlsUI();

            if (this.dragPaused && !this.holdPaused) {
              this.dragPaused = false;
              this.startProgress(false);
            }
            return;
          }

          if (!state.axis && (Math.hypot(dx, dy) > 8 || nativeScrollDistance > 4)) {
            state.axis = nativeScrollDistance > 4 || Math.abs(dx) > Math.abs(dy) * 1.18 ? 'horizontal' : 'vertical';
          }

          if (state.axis !== 'horizontal' || !state.moved) {
            if (this.dragPaused && !this.holdPaused) {
              this.dragPaused = false;
              this.startProgress(false);
            }
            return;
          }

          const target = this.resolveTouchNavigation({ clientX: endX }, state);
          this.commitTouchNavigation(target);

          /* Keep the release animation native on iOS. WebKit continues its own
             momentum + scroll-snap after the finger leaves the screen, which is
             substantially smoother than rewriting scrollLeft or translating the
             track frame-by-frame. Navigation/countdown are already committed
             above, so they do not wait for the native snap to finish. */
          if (target.rewind) {
            requestAnimationFrame(() => this.scrollTouchReleaseToPhysical(target.targetPhysicalIndex));
          }
        };

        this.onNativeTouchEnd = (event) => {
          this.finishNativeTouch(event);
        };

        this.onNativeTouchCancel = (event) => {
          /* iOS/WebKit often emits touchcancel once native scrolling takes over.
             Text selection can also trigger touchcancel, so finishNativeTouch()
             first verifies that this was really a swipe before navigating. */
          this.finishNativeTouch(event);
        };

        this.onSelectionChange = () => {
          const state = this.nativeTouchState;
          if (!state?.contentElement) return;
          if (this.hasChangedTextSelection(state)) state.textSelectionDetected = true;
        };

        document.addEventListener('selectionchange', this.onSelectionChange);
        this.viewport.addEventListener('touchstart', this.onNativeTouchStart, { passive: true });
        this.viewport.addEventListener('touchmove', this.onNativeTouchMove, { passive: true });
        this.viewport.addEventListener('touchend', this.onNativeTouchEnd, { passive: true });
        this.viewport.addEventListener('touchcancel', this.onNativeTouchCancel, { passive: true });

        this.hero.addEventListener('contextmenu', (event) => {
          if (event.target.closest('.cusotm-hero-media')) event.preventDefault();
        });

        this.hero.addEventListener('dragstart', (event) => {
          if (event.target.closest('.cusotm-hero-media')) event.preventDefault();
        });

        this.onVisibilityChange = () => {
          if (document.hidden) {
            this.hiddenPaused = true;
            this.clearHoldTimer();
            this.holdPaused = false;
            this.dragPaused = false;
            this.stopProgress(true);
          } else if (this.hiddenPaused) {
            this.hiddenPaused = false;
            this.startProgress(false);
          }
        };

        this.onBlockSelect = (event) => {
          const slide = event.target?.closest?.('.cusotm-hero-slide');
          if (!slide || !this.contains(slide) || slide.hasAttribute('data-cusotm-loop-clone')) return;
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.goTo(index, false, false);
        };

        this.onResize = () => {
          this.clearScrollSettleTimer();
          this.nativeReleaseTarget = null;
          this.physicalIndex = this.logicalToPhysical(this.index);
          this.teleportToPhysical(this.physicalIndex);
          this.syncMobileLayout();
        };

        document.addEventListener('visibilitychange', this.onVisibilityChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        window.addEventListener('resize', this.onResize, { passive: true });

        if ('ResizeObserver' in window) {
          this.slideResizeObserver = new ResizeObserver(() => this.syncMobileLayout());
        }
      }

      onPointerDown(event) {
        if (event.button !== undefined && event.button !== 0) return;
        if (event.target.closest('a, button, input, textarea, select, label')) return;

        const media = event.target.closest('.cusotm-hero-media');
        const content = event.target.closest('.cusotm-hero-content');
        const interactionSurface = media || content;
        if (!interactionSurface) return;

        const slide = interactionSurface.closest('.cusotm-hero-slide');
        if (!slide) return;

        const logicalIndex = Number(slide.dataset.cusotmLogicalIndex);
        if (logicalIndex !== this.index) return;

        this.cancelMouseSettle();
        this.pendingNavigationIndex = null;
        this.pendingRewind = false;
        this.updateControlsUI();
        this.clearHoldTimer();

        const now = performance.now();
        this.pointerState = {
          id: event.pointerId,
          pointerType: event.pointerType || 'mouse',
          startX: event.clientX,
          startY: event.clientY,
          lastX: event.clientX,
          lastTime: now,
          velocityX: 0,
          moved: false,
          dragging: false,
          axis: null,
          holdTriggered: false,
          startedOnMedia: Boolean(media),
          basePhysicalIndex: this.physicalIndex,
          startScrollLeft: this.viewport.scrollLeft
        };

        if (media && this.holdPauseEnabled) {
          this.holdTimer = window.setTimeout(() => {
            if (!this.pointerState || this.pointerState.moved || this.pointerState.dragging) return;
            this.pointerState.holdTriggered = true;
            this.holdPaused = true;
            this.stopProgress(true);
          }, this.holdDelay);
        }
      }

      onPointerMove(event) {
        const state = this.pointerState;
        if (!state || event.pointerId !== state.id) return;

        const coalescedEvents = event.getCoalescedEvents?.();
        const point = coalescedEvents?.length ? coalescedEvents[coalescedEvents.length - 1] : event;
        const dx = point.clientX - state.startX;
        const dy = point.clientY - state.startY;
        const absX = Math.abs(dx);
        const absY = Math.abs(dy);
        const distance = Math.hypot(dx, dy);
        const axisThreshold = state.pointerType === 'touch' ? 8 : 6;

        if (distance > axisThreshold) {
          state.moved = true;
          this.clearHoldTimer();
        }

        if (state.pointerType === 'touch') {
          const now = performance.now();
          const elapsed = Math.max(1, now - state.lastTime);
          state.velocityX = (point.clientX - state.lastX) / elapsed;
          state.lastX = point.clientX;
          state.lastTime = now;

          if (!state.axis && distance > axisThreshold) {
            if (absX > absY * 1.18) {
              state.axis = 'horizontal';
              this.dragPaused = true;
              this.stopProgress(true);
            } else if (absY > absX * 1.18) {
              state.axis = 'vertical';
            }
          }

          return;
        }

        if (!state.dragging && !state.axis && distance > axisThreshold) {
          if (absX > absY * 1.1 && this.slides.length > 1) {
            state.axis = 'horizontal';
            this.startMouseDrag(event, state);
          } else if (absY > absX * 1.1) {
            state.axis = 'vertical';
          }
        }

        if (!state.dragging) return;

        event.preventDefault();

        const now = performance.now();
        const elapsed = Math.max(1, now - state.lastTime);
        state.velocityX = (point.clientX - state.lastX) / elapsed;
        state.lastX = point.clientX;
        state.lastTime = now;

        let targetScrollLeft = state.startScrollLeft - dx;

        if (!this.loop) {
          const maxScrollLeft = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          if (targetScrollLeft < 0) targetScrollLeft *= 0.32;
          if (targetScrollLeft > maxScrollLeft) {
            targetScrollLeft = maxScrollLeft + (targetScrollLeft - maxScrollLeft) * 0.32;
          }
        }

        this.scheduleMouseDrag(targetScrollLeft);
      }

      startMouseDrag(event, state) {
        state.dragging = true;
        state.moved = true;
        this.clearHoldTimer();
        this.dragPaused = true;
        this.stopProgress(true);
        this.clearScrollSettleTimer();
        this.viewport.classList.add('is-dragging');

        try {
          this.hero.setPointerCapture(event.pointerId);
        } catch (_) {}
      }

      scheduleMouseDrag(scrollLeft) {
        this.pendingMouseScrollLeft = scrollLeft;
        if (this.mouseDragFrame) return;

        this.mouseDragFrame = requestAnimationFrame(() => {
          this.mouseDragFrame = null;
          if (this.pendingMouseScrollLeft === null || !this.viewport) return;
          this.viewport.scrollLeft = this.pendingMouseScrollLeft;
          this.pendingMouseScrollLeft = null;
        });
      }

      cancelMouseDragFrame() {
        if (this.mouseDragFrame) cancelAnimationFrame(this.mouseDragFrame);
        this.mouseDragFrame = null;
        this.pendingMouseScrollLeft = null;
      }

      flushMouseDragPosition() {
        if (this.mouseDragFrame) cancelAnimationFrame(this.mouseDragFrame);
        this.mouseDragFrame = null;

        if (this.pendingMouseScrollLeft !== null && this.viewport) {
          this.viewport.scrollLeft = this.pendingMouseScrollLeft;
        }

        this.pendingMouseScrollLeft = null;
      }

      cancelMouseSettle() {
        if (this.mouseSettleFrame) cancelAnimationFrame(this.mouseSettleFrame);
        this.mouseSettleFrame = null;
        this.isMouseSettling = false;
        this.viewport?.classList.remove('is-settling');
      }

      resolveTarget(index) {
        const lastIndex = this.slides.length - 1;
        let nextIndex = index;
        let targetPhysicalIndex;

        if (this.loop) {
          if (index > lastIndex) {
            nextIndex = 0;
            targetPhysicalIndex = this.loopClonesEnabled ? this.slides.length + 1 : this.logicalToPhysical(nextIndex);
          } else if (index < 0) {
            nextIndex = lastIndex;
            targetPhysicalIndex = this.loopClonesEnabled ? 0 : this.logicalToPhysical(nextIndex);
          } else {
            targetPhysicalIndex = this.logicalToPhysical(index);
          }
        } else if (this.rewind && index > lastIndex) {
          nextIndex = 0;
          targetPhysicalIndex = 0;
        } else {
          nextIndex = Math.max(0, Math.min(lastIndex, index));
          targetPhysicalIndex = this.logicalToPhysical(nextIndex);
        }

        return { nextIndex, targetPhysicalIndex };
      }

      physicalToLogical(physicalIndex) {
        if (!this.loopClonesEnabled) {
          return Math.max(0, Math.min(this.slides.length - 1, physicalIndex));
        }

        if (physicalIndex <= 0) return this.slides.length - 1;
        if (physicalIndex >= this.slides.length + 1) return 0;
        return Math.max(0, Math.min(this.slides.length - 1, physicalIndex - 1));
      }

      resolveTouchNavigation(event, state) {
        const width = this.getViewportWidth();
        const physicalFloat = this.viewport.scrollLeft / width;
        const currentX = Number.isFinite(event?.clientX) ? event.clientX : state.lastX;
        const dx = currentX - state.startX;
        const direction = dx < 0 ? 1 : -1;
        const velocityProjectionMs = 180;
        const projectedPhysical = physicalFloat - (state.velocityX * velocityProjectionMs) / width;
        let targetPhysical = Math.round(projectedPhysical);

        const maxPhysical = Math.max(0, this.physicalSlides.length - 1);
        targetPhysical = Math.max(0, Math.min(maxPhysical, targetPhysical));

        const distanceThreshold = Math.min(90, width * 0.14);
        const velocityThreshold = 0.34;
        const intentionalSwipe = Math.abs(dx) >= distanceThreshold || Math.abs(state.velocityX) >= velocityThreshold;
        const baseLogicalIndex = this.physicalToLogical(state.basePhysicalIndex);
        const lastLogicalIndex = this.slides.length - 1;

        if (this.rewind && baseLogicalIndex === lastLogicalIndex && direction === 1 && intentionalSwipe) {
          return {
            logicalIndex: 0,
            targetPhysicalIndex: 0,
            rewind: true
          };
        }

        if (targetPhysical === state.basePhysicalIndex && intentionalSwipe) {
          const directionalTarget = state.basePhysicalIndex + direction;
          if (directionalTarget >= 0 && directionalTarget <= maxPhysical) {
            targetPhysical = directionalTarget;
          }
        }

        if (!intentionalSwipe) {
          targetPhysical = state.basePhysicalIndex;
        }

        return {
          logicalIndex: this.physicalToLogical(targetPhysical),
          targetPhysicalIndex: targetPhysical,
          rewind: false
        };
      }

      commitTouchNavigation(target) {
        if (!target) return;

        const changedSlide = target.logicalIndex !== this.index;

        this.pendingNavigationIndex = null;
        this.pendingRewind = false;
        this.nativeReleaseTarget = target;
        this.index = target.logicalIndex;
        this.physicalIndex = target.targetPhysicalIndex;

        if (changedSlide) this.progress = 0;

        this.dragPaused = false;
        this.isViewportScrolling = true;
        this.applyActiveState(target.targetPhysicalIndex);
        this.updateControlsUI();
        this.observeActiveSlide();

        /* Start the new slide's timer immediately on finger release. Native Safari
           momentum / scroll-snap may still be settling visually, but it must not
           block the logical slide state or the countdown. */
        this.startProgress(false);
      }

      scrollTouchReleaseToPhysical(physicalIndex) {
        if (!this.viewport) return;

        this.clearScrollSettleTimer();
        const width = this.getViewportWidth();
        const left = physicalIndex * width;

        if (this.reducedMotion) {
          this.viewport.scrollLeft = left;
          this.settleViewportScroll(true);
          return;
        }

        this.viewport.scrollTo({ left, behavior: 'smooth' });
        this.scheduleScrollSettle();
      }

      settleMouseDragToIndex(index, restartProgress = true) {
        const { nextIndex, targetPhysicalIndex } = this.resolveTarget(index);
        const changedSlide = nextIndex !== this.index;

        this.pendingNavigationIndex = null;
        this.index = nextIndex;
        this.physicalIndex = targetPhysicalIndex;

        if (changedSlide) this.progress = 0;

        this.stopProgress(true);
        this.applyActiveState(targetPhysicalIndex);
        this.updateControlsUI();
        this.observeActiveSlide();
        this.syncMobileLayout();
        this.resumeAfterScroll = restartProgress;
        this.animateMouseSettleToPhysical(targetPhysicalIndex);
      }

      animateMouseSettleToPhysical(physicalIndex) {
        if (!this.viewport) return;

        this.cancelMouseSettle();
        this.viewport.classList.add('is-settling');
        this.isMouseSettling = true;
        this.dragPaused = true;
        this.isViewportScrolling = true;
        this.clearScrollSettleTimer();

        const width = this.getViewportWidth();
        const startLeft = this.viewport.scrollLeft;
        const targetLeft = physicalIndex * width;
        const distance = targetLeft - startLeft;
        const pageDistance = Math.abs(distance) / width;
        const duration = this.reducedMotion
          ? 0
          : pageDistance > 1
            ? Math.min(1100, 260 + pageDistance * 160)
            : 150 + pageDistance * 230;

        if (duration === 0 || Math.abs(distance) < 0.5) {
          this.viewport.scrollLeft = targetLeft;
          this.finishMouseSettle();
          return;
        }

        const startedAt = performance.now();

        const tick = (now) => {
          const elapsed = now - startedAt;
          const t = Math.min(1, elapsed / duration);
          const eased = 1 - Math.pow(1 - t, 3);
          this.viewport.scrollLeft = startLeft + distance * eased;

          if (t >= 1) {
            this.viewport.scrollLeft = targetLeft;
            this.mouseSettleFrame = null;
            this.finishMouseSettle();
            return;
          }

          this.mouseSettleFrame = requestAnimationFrame(tick);
        };

        this.mouseSettleFrame = requestAnimationFrame(tick);
      }

      finishMouseSettle() {
        this.isMouseSettling = false;
        this.settleViewportScroll();

        requestAnimationFrame(() => {
          this.viewport?.classList.remove('is-settling');
        });
      }

      onPointerUp(event) {
        const state = this.pointerState;
        if (!state || event.pointerId !== state.id) return;

        this.clearHoldTimer();

        if (state.dragging) {
          this.finishMouseDrag(event, state);
          this.pointerState = null;
          return;
        }

        this.pointerState = null;

        if (state.holdTriggered) {
          this.releaseHold();
          return;
        }

        if (state.startedOnMedia && !state.moved && this.clickToggleEnabled) {
          this.togglePause();
        }
      }

      finishMouseDrag(event, state) {
        this.flushMouseDragPosition();
        this.viewport.classList.add('is-settling');
        this.viewport.classList.remove('is-dragging');

        try {
          this.hero.releasePointerCapture(event.pointerId);
        } catch (_) {}

        const dx = event.clientX - state.startX;
        const width = this.getViewportWidth();
        const distanceThreshold = Math.min(120, width * 0.16);
        const velocityThreshold = 0.42;
        const shouldChange = Math.abs(dx) >= distanceThreshold || Math.abs(state.velocityX) >= velocityThreshold;
        const direction = dx < 0 ? 1 : -1;
        const targetIndex = this.index + direction;
        const targetExists =
          this.loop ||
          (this.rewind && direction === 1 && this.index === this.slides.length - 1) ||
          (targetIndex >= 0 && targetIndex < this.slides.length);

        if (state.holdTriggered) this.holdPaused = false;

        if (shouldChange && targetExists) {
          this.settleMouseDragToIndex(targetIndex, true);
          return;
        }

        this.pendingNavigationIndex = null;
        this.updateControlsUI();
        this.resumeAfterScroll = true;
        this.animateMouseSettleToPhysical(this.physicalIndex);
      }

      cancelPointerInteraction(event) {
        const state = this.pointerState;
        if (!state) return;

        this.clearHoldTimer();

        if (state.dragging) {
          this.flushMouseDragPosition();
        } else {
          this.cancelMouseDragFrame();
        }

        this.pointerState = null;

        if (state.dragging) {
          this.viewport.classList.add('is-settling');
          this.viewport.classList.remove('is-dragging');
          this.resumeAfterScroll = true;
          this.animateMouseSettleToPhysical(this.physicalIndex);
        }

        if (state.holdTriggered) {
          this.holdPaused = false;
        }

        if (!this.isViewportScrolling && !state.dragging) {
          this.dragPaused = false;
          this.startProgress(false);
        }

        if (event?.pointerId !== undefined && state.pointerType !== 'touch') {
          try {
            this.hero.releasePointerCapture(event.pointerId);
          } catch (_) {}
        }
      }

      clearHoldTimer() {
        if (this.holdTimer) window.clearTimeout(this.holdTimer);
        this.holdTimer = null;
      }

      releaseHold() {
        if (!this.holdPaused) return;
        this.holdPaused = false;
        if (!this.isViewportScrolling) this.startProgress(false);
      }

      captureSelectionSnapshot() {
        const selection = window.getSelection?.();
        if (!selection) return null;

        return {
          anchorNode: selection.anchorNode,
          anchorOffset: selection.anchorOffset,
          focusNode: selection.focusNode,
          focusOffset: selection.focusOffset,
          text: selection.toString()
        };
      }

      hasChangedTextSelection(state) {
        const content = state?.contentElement;
        const selection = window.getSelection?.();
        if (!content || !selection || selection.rangeCount === 0 || selection.isCollapsed) return false;

        let intersectsContent = false;
        try {
          intersectsContent = selection.getRangeAt(0).intersectsNode(content);
        } catch (_) {
          const commonNode = selection.getRangeAt(0).commonAncestorContainer;
          const commonElement = commonNode?.nodeType === Node.ELEMENT_NODE ? commonNode : commonNode?.parentElement;
          intersectsContent = Boolean(commonElement && (content === commonElement || content.contains(commonElement)));
        }

        if (!intersectsContent || selection.toString().trim().length === 0) return false;

        const before = state.selectionSnapshot;
        if (!before) return true;

        return (
          selection.anchorNode !== before.anchorNode ||
          selection.anchorOffset !== before.anchorOffset ||
          selection.focusNode !== before.focusNode ||
          selection.focusOffset !== before.focusOffset ||
          selection.toString() !== before.text
        );
      }

      getViewportWidth() {
        return Math.max(1, this.viewport?.clientWidth || this.getBoundingClientRect().width || 1);
      }

      scheduleScrollSettle() {
        this.clearScrollSettleTimer();
        this.scrollSettleTimer = window.setTimeout(() => this.settleViewportScroll(false), 110);
      }

      clearScrollSettleTimer() {
        if (this.scrollSettleTimer) window.clearTimeout(this.scrollSettleTimer);
        this.scrollSettleTimer = null;
      }

      scrollToPhysical(physicalIndex, animate = true) {
        if (!this.viewport) return;

        this.clearScrollSettleTimer();
        const width = this.getViewportWidth();
        const left = physicalIndex * width;
        const smooth = animate && !this.reducedMotion;

        this.dragPaused = true;
        this.isViewportScrolling = smooth;

        if (smooth) {
          this.viewport.scrollTo({ left, behavior: 'smooth' });
          this.scheduleScrollSettle();
        } else {
          this.teleportToPhysical(physicalIndex);
          this.dragPaused = false;
          this.isViewportScrolling = false;
        }
      }

      teleportToPhysical(physicalIndex) {
        if (!this.viewport) return;

        const width = this.getViewportWidth();
        this.suppressScrollEvents = true;
        this.viewport.style.scrollSnapType = 'none';
        this.viewport.scrollLeft = physicalIndex * width;
        this.physicalIndex = physicalIndex;

        requestAnimationFrame(() => {
          if (!this.viewport) return;
          this.viewport.style.scrollSnapType = '';
          requestAnimationFrame(() => {
            this.suppressScrollEvents = false;
          });
        });
      }

      settleViewportScroll(force = false) {
        if (
          !this.viewport ||
          this.suppressScrollEvents ||
          this.pointerState?.dragging ||
          this.nativeTouchState
        ) return;

        this.clearScrollSettleTimer();

        const width = this.getViewportWidth();
        const maxPhysicalIndex = Math.max(0, this.physicalSlides.length - 1);

        if (this.nativeReleaseTarget && !force) {
          const targetLeft = this.nativeReleaseTarget.targetPhysicalIndex * width;
          const distanceToTarget = Math.abs(this.viewport.scrollLeft - targetLeft);

          /* The 110 ms fallback timer is only housekeeping now. It must never
             create a dead period between gestures or override the slide state
             while native Safari momentum is still running. */
          if (distanceToTarget > Math.max(2, width * 0.01)) {
            this.scheduleScrollSettle();
            return;
          }
        }

        let settledPhysical = Math.round(this.viewport.scrollLeft / width);
        settledPhysical = Math.max(0, Math.min(maxPhysicalIndex, settledPhysical));

        let logicalIndex;
        let normalizedPhysical = settledPhysical;

        if (this.loopClonesEnabled && settledPhysical === 0) {
          logicalIndex = this.slides.length - 1;
          normalizedPhysical = this.slides.length;
        } else if (this.loopClonesEnabled && settledPhysical === this.slides.length + 1) {
          logicalIndex = 0;
          normalizedPhysical = 1;
        } else {
          logicalIndex = this.loopClonesEnabled ? settledPhysical - 1 : settledPhysical;
          logicalIndex = Math.max(0, Math.min(this.slides.length - 1, logicalIndex));
        }

        const changedSlide = logicalIndex !== this.index;
        this.pendingNavigationIndex = null;
        this.pendingRewind = false;
        this.nativeReleaseTarget = null;
        this.index = logicalIndex;
        this.physicalIndex = normalizedPhysical;

        if (normalizedPhysical !== settledPhysical) {
          this.teleportToPhysical(normalizedPhysical);
        }

        if (changedSlide) this.progress = 0;

        this.isViewportScrolling = false;
        this.dragPaused = false;
        this.applyActiveState(normalizedPhysical);
        this.updateControlsUI();
        this.observeActiveSlide();
        this.syncMobileLayout();

        if (this.resumeAfterScroll || changedSlide || this.autoplayEnabled) {
          this.resumeAfterScroll = false;
          this.startProgress(false);
        }
      }

      goTo(index, restartProgress = true, animate = true) {
        if (!this.slides.length) return;

        this.cancelMouseSettle();
        this.pendingNavigationIndex = null;
        this.pendingRewind = false;
        this.nativeReleaseTarget = null;

        const { nextIndex, targetPhysicalIndex } = this.resolveTarget(index);
        const changedSlide = nextIndex !== this.index;
        this.index = nextIndex;
        this.physicalIndex = targetPhysicalIndex;

        if (changedSlide) this.progress = 0;
        this.stopProgress(true);
        this.applyActiveState(targetPhysicalIndex);
        this.updateControlsUI();
        this.observeActiveSlide();
        this.syncMobileLayout();

        if (!animate) {
          this.teleportToPhysical(targetPhysicalIndex);
          this.dragPaused = false;
          if (restartProgress) this.startProgress(false);
          return;
        }

        this.resumeAfterScroll = restartProgress;
        this.scrollToPhysical(targetPhysicalIndex, true);
      }

      applyActiveState(activePhysicalIndex = this.physicalIndex) {
        this.physicalSlides.forEach((slide, physicalSlideIndex) => {
          const isClone = slide.hasAttribute('data-cusotm-loop-clone');
          const logicalIndex = Number(slide.dataset.cusotmLogicalIndex);
          const logicalActive = logicalIndex === this.index;
          const physicallyActive = physicalSlideIndex === activePhysicalIndex;

          if (!isClone) {
            slide.setAttribute('aria-hidden', logicalActive ? 'false' : 'true');
            slide.toggleAttribute('inert', !logicalActive);
          }

          slide.querySelectorAll('video').forEach((video) => {
            if (!physicallyActive) {
              video.pause();
            } else if (video.autoplay && !this.reducedMotion) {
              video.play().catch(() => {});
            }
          });
        });
      }

      observeActiveSlide() {
        if (!this.slideResizeObserver) return;
        this.slideResizeObserver.disconnect();
        const activeSlide = this.slides[this.index];
        if (activeSlide) this.slideResizeObserver.observe(activeSlide);
      }

      syncMobileLayout() {
        if (!this.hero || !this.viewport || !this.slides.length) return;

        const isMobile = this.mobileQuery?.matches ?? window.innerWidth < 750;
        const layoutSlides = this.physicalSlides || this.slides;

        const hasVisibleBelowContent = (slide) => {
          if (!isMobile || !slide) return false;

          return Array.from(slide.querySelectorAll('.cusotm-hero-content--mobile-below')).some((content) => {
            const styles = getComputedStyle(content);
            return styles.display !== 'none' && styles.visibility !== 'hidden';
          });
        };

        layoutSlides.forEach((slide) => {
          const hasBelowContent = hasVisibleBelowContent(slide);
          slide.classList.toggle('cusotm-hero-slide--has-mobile-content-below', hasBelowContent);
          slide.style.removeProperty('--cusotm-slide-controls-bottom');

          if (!hasBelowContent) return;

          const media = Array.from(slide.querySelectorAll('.cusotm-hero-media')).find((element) => {
            const styles = getComputedStyle(element);
            return styles.display !== 'none' && element.getBoundingClientRect().height > 0;
          });

          if (!media) return;

          const slideRect = slide.getBoundingClientRect();
          const mediaRect = media.getBoundingClientRect();
          const contentHeight = Math.max(0, slideRect.bottom - mediaRect.bottom);
          const controlsBottom = Math.round(contentHeight + 20);
          slide.style.setProperty('--cusotm-slide-controls-bottom', `${controlsBottom}px`);
        });

        const activeSlide = this.slides[this.index];
        const contentBelow = hasVisibleBelowContent(activeSlide);
        this.hero.classList.toggle('is-mobile-content-below', contentBelow);
        this.hero.style.removeProperty('--cusotm-fixed-controls-bottom');

        if (this.controlsMode === 'fixed' && contentBelow && activeSlide) {
          const activeControlsBottom = activeSlide.style.getPropertyValue('--cusotm-slide-controls-bottom');
          if (activeControlsBottom) {
            this.hero.style.setProperty('--cusotm-fixed-controls-bottom', activeControlsBottom);
          }
        }

        if (!contentBelow) {
          this.viewport.style.height = '';
          this.hero.style.removeProperty('--cusotm-active-slide-height');
          return;
        }

        requestAnimationFrame(() => {
          if (!this.mobileQuery?.matches) return;
          const currentSlide = this.slides[this.index];
          if (!hasVisibleBelowContent(currentSlide)) return;

          const slideHeight = Math.ceil(currentSlide.scrollHeight);
          if (slideHeight > 0) {
            const currentHeight = parseFloat(this.viewport.style.height) || 0;
            if (Math.abs(currentHeight - slideHeight) > 1) {
              this.viewport.style.height = `${slideHeight}px`;
              this.hero.style.setProperty('--cusotm-active-slide-height', `${slideHeight}px`);
            }
          }
        });
      }

      next() {
        if (!this.loop && !this.rewind && this.index >= this.slides.length - 1) {
          this.stopProgress(true);
          return;
        }
        this.goTo(this.index + 1, true, true);
      }

      previous() {
        if (!this.loop && this.index <= 0) return;
        this.goTo(this.index - 1, true, true);
      }

      togglePause() {
        this.userPaused = !this.userPaused;
        this.updatePauseButtons();
        this.updateControlsUI();

        if (this.userPaused) {
          this.stopProgress(true);
        } else {
          this.startProgress(false);
        }
      }

      updatePauseButtons() {
        this.pauseButtons?.forEach((button) => {
          button.classList.toggle('is-paused', this.userPaused);
          button.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
          button.setAttribute('aria-label', this.userPaused ? 'Slideshow abspielen' : 'Slideshow pausieren');
        });
      }

      canAutoplay() {
        return (
          this.slides.length > 1 &&
          this.autoplayEnabled &&
          !this.reducedMotion &&
          !this.userPaused &&
          !this.holdPaused &&
          !this.dragPaused &&
          !this.hiddenPaused
        );
      }

      startProgress(reset = true) {
        this.cancelProgressFrame();

        if (reset) this.progress = 0;
        this.updateControlsUI();

        if (!this.canAutoplay()) return;

        this.startedAt = performance.now() - this.progress * this.delay;

        const tick = (now) => {
          this.progress = Math.min(1, (now - this.startedAt) / this.delay);
          this.updateControlsUI();

          if (this.progress >= 1) {
            this.progress = 0;
            this.next();
            return;
          }

          this.raf = requestAnimationFrame(tick);
        };

        this.raf = requestAnimationFrame(tick);
      }

      stopProgress(preserve = false) {
        this.cancelProgressFrame();
        if (!preserve) this.progress = 0;
        this.updateControlsUI();
      }

      cancelProgressFrame() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
      }

      updateControlsUI() {
        const displayIndex = this.pendingNavigationIndex ?? this.index;
        const hasPendingNavigation = this.pendingNavigationIndex !== null;

        this.controlSets?.forEach(({ ownerIndex, paginationButtons }) => {
          paginationButtons.forEach((button, buttonIndex) => {
            const activeIndex = this.controlsMode === 'fixed' ? displayIndex : ownerIndex;
            const active = buttonIndex === activeIndex;
            const currentActive = active && activeIndex === displayIndex;

            button.classList.toggle('is-active', active);
            button.classList.toggle('is-complete', buttonIndex < activeIndex);
            button.classList.toggle('is-current-paused', currentActive && this.userPaused);
            button.setAttribute('aria-current', active ? 'true' : 'false');

            const progress = currentActive ? (hasPendingNavigation ? 0 : this.progress) : 0;
            button.style.setProperty('--cusotm-progress', progress);
          });
        });

        this.updatePauseButtons();
      }
    }

    customElements.define('cusotm-responsive-hero', CusotmResponsiveHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
